//
//
//
//
//
//
//
//
//
//
//
var script = {
  props: {
    src: {
      type: [String, Object],
      required: true
    },
    alt: {
      type: String,
      default: null
    },
    focus: {
      type: String,
      default: undefined
    },
    width: {
      type: [String, Number],
      default: undefined
    },
    height: {
      type: [String, Number],
      default: undefined
    },
    aspectRatio: {
      type: Number,
      default: undefined
    }
  },
  computed: {
    asset() {
      if (this.isStringSrc) {
        return {
          permalink: this.src
        };
      }

      return this.src;
    },

    isStringSrc() {
      return typeof this.src === 'string' || this.src instanceof String;
    },

    assetUrl() {
      var _this$asset;

      if (!((_this$asset = this.asset) === null || _this$asset === void 0 ? void 0 : _this$asset.permalink)) {
        return null;
      }

      return this.asset.permalink.replace(/https?:\/\/[^/]+/i, '');
    },

    assetAlt() {
      if (this.alt) {
        return this.alt;
      }

      return this.asset.alt;
    },

    imageFocus() {
      if (this.focus) {
        return this.focus;
      }

      if (!this.asset.focus && !this.asset.focus_css) {
        return undefined;
      }

      if (!this.asset.width || !this.asset.height) {
        return undefined;
      }

      let x, y;

      if (this.asset.focus) {
        [x, y] = this.asset.focus.split('-');
      } else if (this.asset.focus_css) {
        [x, y] = this.asset.focus_css.replace(/%/g, '').split(' ');
      }

      if (parseFloat(x) === 50 || parseFloat(y) === 50) {
        return undefined;
      }

      x = x * this.asset.width / 100;
      y = y * this.asset.height / 100;
      return [parseInt(x), parseInt(y)];
    },

    imageWidth() {
      if (this.width) {
        return this.width;
      }

      if (this.asset.width && this.asset.height || this.asset.width && this.asset.aspectRatio) {
        return this.asset.width;
      }

      if (this.asset.aspectRatio && this.asset.height && Number(this.asset.height) > 0) {
        return this.asset.height * this.asset.aspectRatio;
      }

      return undefined;
    },

    imageHeight() {
      if (this.height) {
        return this.height;
      }

      if (this.asset.width && this.asset.height || this.asset.height && this.asset.aspectRatio) {
        return this.asset.height;
      }

      if (this.asset.aspectRatio && this.asset.width && Number(this.asset.width) > 0) {
        return this.asset.width / this.asset.aspectRatio;
      }

      return undefined;
    },

    imageAspectRatio() {
      if (this.aspectRatio) {
        return this.aspectRatio;
      }

      if (this.asset.aspectRatio) {
        return this.asset.aspectRatio;
      }

      if (this.imageWidth && this.imageHeight) {
        return this.imageWidth / this.imageHeight;
      }

      return undefined;
    }

  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

/* script */
const __vue_script__ = script;
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.assetUrl ? _c('CloudinaryImage', _vm._b({
    attrs: {
      "focal": _vm.imageFocus,
      "src": _vm.assetUrl,
      "alt": _vm.assetAlt,
      "aspect-ratio": _vm.imageAspectRatio
    }
  }, 'CloudinaryImage', _vm.$attrs, false)) : _vm._e();
};

var __vue_staticRenderFns__ = [];
/* style */

const __vue_inject_styles__ = undefined;
/* scoped */

const __vue_scope_id__ = undefined;
/* module identifier */

const __vue_module_identifier__ = undefined;
/* functional template */

const __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

// Import vue component

const install = function installAppImageStatamic(Vue, options) {
  if (install.installed) return;
  install.installed = true;
  Vue.component('AppImage', __vue_component__);
}; // Create module definition for Vue.use()
// to be registered via Vue.use() as well as Vue.component()


__vue_component__.install = install; // Export component by default
// also be used as directives, etc. - eg. import { RollupDemoDirective } from 'rollup-demo';
// export const RollupDemoDirective = component;

export default __vue_component__;
